import { firebaseAuth } from "../firebase";

/**
 * Trustworthy actor stamp for audited Firestore writes.
 *
 * Firestore triggers (the audit producers in the Cloud Functions repo) cannot
 * see Firebase Auth context, so every audited client write must carry who made
 * it. This `updatedBy` is made NON-FORGEABLE by the security rules: a write
 * whose `updatedBy.uid` differs from `request.auth.uid` is rejected. A client
 * therefore cannot frame another user.
 */
export interface AuditActor {
  uid: string;
  email: string | null;
}

/** The current authenticated user as an audit actor. */
export function currentActor(): AuditActor {
  const user = firebaseAuth.currentUser;
  return {
    uid: user?.uid ?? "",
    email: user?.email ?? null,
  };
}

/**
 * Spread into an audited write to stamp the actor + edit time:
 *   updateDoc(ref, { ...someFields, ...auditMeta() })
 * `updatedAt` is Unix seconds, matching the existing `lastEditTimestamp` style.
 */
export function auditMeta(): { updatedBy: AuditActor; updatedAt: number } {
  return {
    updatedBy: currentActor(),
    updatedAt: Math.floor(Date.now() / 1000),
  };
}
